import { Directive, EventEmitter, Output } from "@angular/core";
import { translateSafely } from "@ankaadia/ankaadia-shared-frontend";
import { TranslocoService } from "@jsverse/transloco";
import { MessageService } from "primeng/api";
import { IresultInfo } from "../../shared/write-tables.service";

@Directive()
export abstract class ExcelBaseComponent {
  @Output() readonly isBusy = new EventEmitter<boolean>();

  readonly language = this.transloco.getActiveLang();

  constructor(
    protected readonly transloco: TranslocoService,
    protected readonly messageService: MessageService
  ) {}

  myTranslation(key: string): string {
    return translateSafely(key);
  }

  sendTableUpdateMessage(result: IresultInfo): void {
    this.messageService.add({
      severity: result.finishState,
      detail: result.issues
        ? translateSafely("officeAddin.tableWriteIssue") + result.issues
        : translateSafely("officeAddin.tableWriteSuccess") + ` (${result.timeTaken}s.)`,
      life: result.issues ? 5000 : 2000,
    });
  }

  sendFailureMessage(message: string): void {
    this.messageService.add({
      severity: "error",
      detail: message,
    });
  }

  setBusy(busyState: boolean): void {
    this.isBusy.emit(busyState);
  }
}
